import { gql } from "@apollo/client";

export interface SelectOptionType {
    value: string;
    label: string;
};

export const SELECT_OPTION_FIELDS = gql`
    fragment SelectOptionFields on SelectOptionType {
        value
        label
    }
`;